import { TextBadge } from 'components/Badge/TextBadge';
import { SearchFacetAccordionItem } from 'modules/search/components/Facet/AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from 'modules/search/components/Facet/Dropdown/SearchFacetDropdown';
import { SearchFacetCheckboxOptions } from 'modules/search/components/Facet/Options/SearchFacetCheckboxOptions';
import { useSearchFacetSelectedValues } from 'modules/search/hooks/facets/useSearchFacetSelectedValues';
import type { SearchFacetVariant } from 'modules/search/types/SearchFacetVariant';
import { PAYMENT_LEVELS } from 'utils/constants/general/paymentLevels';

type Props = {
  variant?: SearchFacetVariant;
};

export function PaymentFacet({ variant = 'dropdown' }: Props) {
  // @ts-expect-error Need to figure out better type refinement
  const selectedFacetValues = useSearchFacetSelectedValues('payment');

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="payment"
      icon="money"
      label={
        <>
          {getText('Compensation')}{' '}
          <TextBadge content={selectedFacetValues.length} />
        </>
      }
    >
      <SearchFacetCheckboxOptions
        facetType="payment"
        initialValue={selectedFacetValues}
        options={Object.entries(PAYMENT_LEVELS).map(([name, label]) => ({
          name,
          label,
        }))}
      />
    </FacetVariant>
  );
}
